import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import subsection_style from "./style.js";

import LazyVideo from "./lazy-video";

import teaser1 from "./video/track-teaser.mp4"
import teaser3 from "./video/astronaut-rotate.mp4"
import teaser2 from "./video/seek-teaser.mp4"
import teaser4 from "./video/explosion.mp4"

import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";

// import MyCarousel from "./Carousel.js";

const Abstract = ({ mobile }) => (
  <div>
    <Grid columns={4}>
     <Grid.Row>
        <Grid.Column>
          <p align="center">
          </p>
          <LazyVideo src={teaser1}></LazyVideo>
          <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera first
  <strong style={{ color: "blue" }}> tracks</strong> a running dog. Then, the camera
  <strong style={{ color: "blue" }}> switches focus</strong> to a static bicycle leaning against a tree. 
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A golden retriever runs through a grassy field, tongue lolling out, while the bike rests on a tree surrounded by fallen leaves.
</p>
        </Grid.Column>
        <Grid.Column>
          <p align="center">
          </p>
          <LazyVideo src={teaser2}></LazyVideo>
                          <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pans around, searching</strong> for a static colorful birdhouse. Upon finding it, the camera 
  <strong style={{ color: "blue" }}> locks focus and pushes in</strong> on the hand-painted designs.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A birdhouse hangs from a low branch, surrounded by greenery.
</p>
        </Grid.Column>
         <Grid.Column>
                   <p align="center">
          </p>
          <LazyVideo src={teaser3}></LazyVideo>
                          <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> rotates 180 degrees in place.</strong> 
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> An astronaut in a white spacesuit slowly spins weightlessly in the silence of outer space in the spaceship.
</p>
        </Grid.Column>

        <Grid.Column>
                   <p align="center">
          </p>
          <LazyVideo src={teaser4}></LazyVideo>
                      <p>
  <strong style={{ color: "blue" }}>Camera:</strong> The camera 
  <strong style={{ color: "blue" }}> pushes forward</strong> with 
  <strong style={{ color: "blue" }}> intermittent explosive tremors, focusing</strong> on a worn-out teddy bear lying on scorched ground.
<br></br>
  <strong style={{ color: "red" }}>Content:</strong> A car explodes in a fiery blast, sending debris and dust into the air.
</p>
        </Grid.Column>

      </Grid.Row>
    </Grid>
  </div>
);

export default Abstract;
